export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const headerHeight = 72;
      const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20cinematic%20composition%20with%20warm%20golden%20and%20coral%20red%20gradients%2C%20soft%20flowing%20curves%20suggesting%20film%20reels%20and%20digital%20media%20streams%2C%20luxurious%20dark%20background%20with%20elegant%20warm%20light%20rays%2C%20premium%20entertainment%20brand%20atmosphere%2C%20sophisticated%20abstract%20geometric%20patterns%2C%20professional%204K%20digital%20art%20style%2C%20refined%20and%20modern%20composition%20with%20deep%20contrast&width=1600&height=900&seq=hero-bg-91md-01&orientation=landscape"
          alt="91麻豆免费视频网站 - 高清视频在线观看平台视觉"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs font-medium text-primary-300 whitespace-nowrap">每日更新 · 高清畅享</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              91麻豆免费视频网站
              <br />
              <span className="text-primary-400">高清视频在线观看平台</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-white/70 font-heading italic">
              超清画质 · 流畅不卡顿 · 海量资源每日更新
            </p>

            <p className="mt-6 text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0">
              91麻豆免费视频网站致力于打造国内领先的91高清视频在线观看专区，覆盖91国产高清视频、超清视频在线观看等丰富内容。每日更新海量高清影视在线资源，采用先进流媒体技术确保流畅播放体验，画质清晰不卡顿，让您随时随地畅享高品质视频内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">20000+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">高清视频资源</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">每日更新</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">内容持续上新</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">1080P+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">超清画质保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-10">
              <a
                href="#media"
                onClick={(e) => handleScroll(e, '#media')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full cursor-pointer transition-all duration-200 border border-white/30 whitespace-nowrap text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-950/40">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20media%20composition%20with%20warm%20cinematic%20aesthetic%2C%20glowing%20geometric%20shapes%20in%20coral%20red%20and%20amber%20gold%20tones%2C%20stylized%20film%20strip%20and%20play%20button%20elements%2C%20dark%20sophisticated%20background%20with%20soft%20bokeh%20light%20effects%2C%20premium%20video%20streaming%20concept%20art%2C%20clean%20modern%20design%20with%20smooth%20gradients%2C%20high%20contrast%20elegant%20composition&width=800&height=600&seq=hero-visual-91md&orientation=landscape"
                alt="91麻豆免费视频网站 - 高清视频流媒体平台视觉展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}